/**
 * Created by wangshhj on 2018/1/10.
 */
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
//import OriginModal from 'bee-modal';
import { Modal as OriginModal } from '@tinper/next-ui';
import { getSysFieldid, PubSub, getSafeRandom, isFunction, tinperClsPrefix, getMultiLang, ViewModel, microAppUtil } from '@platform/api';
import classnames from 'classnames';
import MaxZoomBtn from '../MaxZoomBtn';
import Tooltip from '../Tooltip';

//require('bee-modal/build/Modal.css');
require('./index.less');

const footerDefaultProps = {
    componentClass: 'div',
    clsPrefix: "".concat("wui-modal-footer"),
};

const headerDefaultProps = {
    'aria-label': 'Close',
    "closeButton": false,
    "clsPrefix": "".concat("wui-modal-header"),
};

const titleDefaultProps = {
    componentClass: 'h4',
    clsPrefix: "".concat("wui-modal-title"),
};

var bodyDefaultProps = {
    componentClass: 'div',
    clsPrefix: "".concat("wui-modal-body"),
};

var modalDefaultProps = {
    componentClass: 'div',
    clsPrefix: "".concat("wui-modal"),
};

const typeMap = { junior: true, senior: true, combine: true, max: true };

// 不能用于存储其他引用对象，避免出现内存泄漏
// const modalManager = new Map([['__base_zIndex__', '']]);
const modalManager = new Map();

// 弹窗的基础className
const defaultModalClassName = 'base-modal';
const defaultModalHeaderClassName = 'base-modal-header';
const defaultModalBodyClassName = 'base-modal-body';
const defaultModalFooterClassName = 'base-modal-footer';
// 禁用背景的按钮快捷键
const disabledBgBtnHotkey = 'disabled-bg-btn';
// 当前是否全屏
let isMax = false;
// 按钮多语
let langJson = {};
// 默认zIndex
const defaultZIndex = 200;
class Modal extends Component {
    constructor(props) {
        super(props);
        // this.timer = null;
        // this.getDomTimer = null;
        this.state = { initModalBodyHeight: '' };
        this.uuid = props.uuid || Date.now() + getSafeRandom();
        this.defaultPopContainer = microAppUtil.getPopContainer();
        this.defaultBody = microAppUtil.getDocument();
        this.bodyRect = this.defaultBody.getBoundingClientRect();
        this.defaultBodyHeight = this.bodyRect.bottom - this.bodyRect.top;
    }
    UNSAFE_componentWillMount() {
        let callback = json => {
            langJson = json;
        };
        // moduleId为所需加载langJson文件夹名称前缀
        getMultiLang({ moduleId: 'common_icon_title', callback });
    }
    componentWillUnmount() {
        // this.timer && clearTimeout(this.timer);
        // this.getDomTimer && clearTimeout(this.getDomTimer);
        // 没有在modal里subscribe但是却做了unsubscribe
        // 导致modal的modelResizeEnd和MODAL的通知别的组件都接收不到了
        // PubSub.unsubscribe('modelResizeEnd');
        // PubSub.unsubscribe('MODAL');
        microAppUtil.removeEventListener('visibilitychange', this.handleVisibilityChange);
        document.removeEventListener('mousedown', this.handleIframeDragStart, true);
        this.handleIframeDragEnd();
        modalManager.delete(this.uuid);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        let type = this.props.type;
        if (nextProps.type != type) {
            let currentModal = ReactDOM.findDOMNode(this);
            let content = currentModal && currentModal.querySelector(`.${defaultModalClassName}`);
            if (content) {
                let modalResizeWrap = content.querySelector('.modal-content-resizeWrap');
                let dialog = content.querySelector(`.${defaultModalClassName}`);
                let modalBody = content.querySelector(`.${defaultModalBodyClassName}`);
                if (nextProps.type === 'max' && (modalBody || modalResizeWrap)) {
                    this.setState({
                        initModalBodyHeight: modalBody.offsetHeight,
                        modalResizeWrapHeight: modalResizeWrap && modalResizeWrap.style.height,
                        modalResizeWrapWidth: modalResizeWrap && modalResizeWrap.style.width,
                        modalResizeWrapTransform: modalResizeWrap && modalResizeWrap.style.transform,
                        dialogTop: dialog && dialog.style.top,
                    });
                    modalBody && (modalBody.style.height = document.body.offsetHeight - 32 - 40 - 44 + 'px');
                    if (modalResizeWrap) {
                        // modalResizeWrap.style.height = document.body.offsetHeight - 32 + 'px';
                        modalResizeWrap.style.height = 'auto';
                        modalResizeWrap.style.width = 'auto';
                        modalResizeWrap.style.transform = 'translate(0px, 0px)';
                    }
                    dialog && (dialog.style.top = '0');
                } else {
                    modalBody && this.state.initModalBodyHeight && (modalBody.style.height = this.state.initModalBodyHeight + 'px');
                    if (modalResizeWrap) {
                        modalResizeWrap.style.height = this.state.modalResizeWrapHeight ? this.state.modalResizeWrapHeight : 'auto';
                        modalResizeWrap.style.width = this.state.modalResizeWrapWidth ? this.state.modalResizeWrapWidth : 'auto';
                        modalResizeWrap.style.transform = this.state.modalResizeWrapTransform ? this.state.modalResizeWrapTransform : 'translate(0px, 0px)';
                    }
                    dialog && (dialog.style.top = this.state.dialogTop ? this.state.dialogTop : '0');
                    this.setState({
                        initModalBodyHeight: '',
                        modalResizeWrapHeight: '',
                        modalResizeWrapWidth: '',
                        modalResizeWrapTransform: '',
                        dialogTop: '',
                    });
                }
            }
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        let { type, includeTable } = this.props;
        if ((prevProps.type === 'max' && type !== 'max') || (prevProps.type !== 'max' && type === 'max')) {
            let currentModal = ReactDOM.findDOMNode(this);
            let { onResizeStop, indexInfo, className, id } = this.props;
            onResizeStop && onResizeStop();
            PubSub.publish('modelResizeEnd', { indexInfo, className, id });
            PubSub.publish('MODAL', { sence: 'modal', currentModal });
        }
        if (includeTable) {
            let currentModal = ReactDOM.findDOMNode(this);
            PubSub.publish('MODAL', { sence: 'modal', currentModal });
        }
    }

    componentDidMount() {
        microAppUtil.addEventListener('visibilitychange', this.handleVisibilityChange);
        if (this.props.draggable !== false) {
            document.addEventListener('mousedown', this.handleIframeDragStart, true);
        }
    }

    handleVisibilityChange = data => {
        if (data.visibilityState === "visible") {
            if (this.reRender) {
                this.forceUpdate(() => {
                    this.reRender = false;
                });
            }
        }
    }

    // 拖拽开始时，若弹窗内含iframe，临时禁用iframe的pointer-events，
    // 使mouseup能被外部document捕获，避免拖拽后弹窗一直跟随鼠标
    handleIframeDragStart = (e) => {
        const modalDom = ReactDOM.findDOMNode(this);
        if (!modalDom || !modalDom.contains(e.target)) return;
        const header = modalDom.querySelector('.dnd-handle');
        if (!header || !header.contains(e.target)) return;
        const iframes = modalDom.querySelectorAll('iframe');
        if (!iframes.length) return;
        this._dragIframes = Array.from(iframes);
        this._dragIframes.forEach(iframe => { iframe.style.pointerEvents = 'none'; });
        document.addEventListener('mouseup', this.handleIframeDragEnd, true);
    };

    handleIframeDragEnd = () => {
        if (this._dragIframes) {
            this._dragIframes.forEach(iframe => { iframe.style.pointerEvents = ''; });
            this._dragIframes = null;
        }
        document.removeEventListener('mouseup', this.handleIframeDragEnd, true);
    };
    getContainer = () => {
        return microAppUtil.getDocument();
    }

    onEscapeKeyUp = () => {
        // esc的時候先關閉  toast提示和日期面板  然後再執行彈窗的關閉事件  by bbqin
        // 获取所有日期面板dom 并转化为数组
        const datePanels = Array.prototype.slice.call(this.defaultBody.querySelectorAll('.nc-date-picker-dropdown'), 0);
        // 只要有一个日期面板未关闭 则 hasDatePanel为true
        const hasDatePanel = datePanels.length > 0 && datePanels.some(panel => getComputedStyle(panel).getPropertyValue('display') === 'block');
        this.escKeyed = !!(
            document && (document.querySelector('.toast-zijinyun-project') || hasDatePanel)
        );
        this.props.onEscapeKeyUp && this.props.onEscapeKeyUp();
    };

    onHide = () => {
        const datePanels = Array.prototype.slice.call(this.defaultBody.querySelectorAll('.nc-date-picker-dropdown'), 0);
        const hasDatePanel = datePanels.length && datePanels.some(panel => getComputedStyle(panel).getPropertyValue('display') === 'block');
        let canClose = !(
            document && (document.querySelector('.toast-zijinyun-project') || hasDatePanel)
        );
        // console.log('escKeyed', this.escKeyed, 'canClose', canClose);
        // 由於要兼容  點擊x和esc兩種情況  所有是 ！==true
        if (this.escKeyed !== true || canClose) {
            this.props.onHide && this.props.onHide();
        }else{
            return new Promise((resolve, reject) => {
                resolve(false);
            });
        }
    };
    /**
     * 判断当前的modal是不是顶层的modal  by bbqin
     */
    isTopModal = () => {
        let referModal = this.defaultBody.querySelector('.refer-pop-window.disabled-bg-btn');

        if (referModal) {
            return false;
        }
        //如果页面中有popconfirm,只有一个，且zIndex是最高（最高先不判断）
        let popconfirm = this.defaultBody.querySelectorAll('.nc-popconfirm');
        if (popconfirm.length === 1) {
            return false;
        }
        // if (this.modal) {
        //     let modals = this.modal.props.manager.modals;
        //     return (
        //         ReactDOM.findDOMNode(this.modal) ===
        //         ReactDOM.findDOMNode(modals[modals.length - 1])
        //     );
        // }
        const current = modalManager.get(this.uuid) || {};
        // 没有传入zIndex 或者已经计算的zIndex > 传入zIndex
        if (current.visible) {
            // 取出已经展示弹窗的最高层级
            let topZIndex, topModalId;
            modalManager.forEach((value, key, map) => {
                if (value.visible && !isNaN(value.zIndex) && (value.zIndex > topZIndex || topZIndex === undefined)) {
                    topZIndex = value.zIndex;
                    topModalId = key;
                }
            });
            return topModalId === this.uuid;
        }
        return false;
    };

    /**
     * 弹窗完成显示添加自动聚焦焦点的操作
     * @param {*} modalDom
     */
    onEnteredHandle(modalDom) {
        let { modalAutoFocus = true } = this.props;
        let modalBody = modalDom.querySelector(`.${defaultModalBodyClassName}`);
        if (modalAutoFocus && modalBody) {
            modalBody.tabIndex = '0';
            modalBody.focus();
        }
        setTimeout(() => {
            this.props.onEntered && this.props.onEntered(modalDom);
        }, 200);
    }

    /**
     * 显示开始
     */
    onEnterHandle(modalDom) {
        // TODO 使用bodyStyle属性给body设置样式，但是现在tinper的body结构中包含我们自己的header、body、footer，
        //      即我们的body和tinper的body结构不精准匹配，因此设置bodyStyle不准确，待tinper回复方案

        // 解决表格内焦点回执的问题  暂时方案 TODO
        // this.prevActiveElement = null;
        // modalDom.id = this.props.id;
        // this.prevActiveElement = document.activeElement;

        // let { className, resizable, bodyHeight, size, max, type } = this.props;
        // let content = modalDom.querySelector(`.wui-modal-content`); // 换成其他dom 比如modal
        // if (content) {
        //     let modalBody = content.querySelector(`.base-modal-body`);
        //     let customType = this.getCustomType(className, type);
        //     if (modalBody) {
        //         //给王印（孙泽光部门）加可以设置模态框高度属性
        //         if (bodyHeight) {
        //             modalBody.style.height = bodyHeight;
        //         } else if (customType) {
        //             if (customType === 'bill-track') {
        //                 modalBody.style.maxHeight =
        //                     document.body.offsetHeight - 40 - 60 + 'px';
        //             } else {
        //                 modalBody.classList &&
        //                     modalBody.classList.add(
        //                         `u-modal-${customType}-body`,
        //                     );
        //             }
        //         } else if (size == 'max' || type == 'max') {
        //             modalBody.style.height = document.body.offsetHeight - 32 - 40 - 44 + 'px';

        //         } else {
        //             //给非定制类型的modal设置最大高度 可视区高度减去nc-modal的padding、u-modal-body的padding、
        //             //modalHeader的高度、modalFooter的高度  上下margin的高度
        //             modalBody.style.maxHeight =
        //                 document.body.offsetHeight - 32 - 40 - 44 + 'px';
        //             // document.body.offsetHeight - 32 - 40 - 44 - 60 + 'px';  // 为了可以最大化 这里不能这样写
        //         }
        //     }
        //     try {
        //         if (resizable !== false) {
        //             content.parentElement.parentElement.classList.add(
        //                 'modal-content-resizeWrap-parent',
        //             );
        //         } else {
        //             content.parentElement.classList.add(
        //                 'modal-content-parent',
        //             );
        //         }
        //     } catch (err) { console.log(err); }
        // }
        // this.props.onEnter && this.props.onEnter();
    }

    onShowHandle() {
        // let { modalAutoFocus = true, fieldid } = this.props;
        // if(fieldid){
        //     fieldid = fieldid +'_modal-area';
        // }else{
        //     fieldid = '_modal-area';
        // }
        // let modalDom = document.querySelector(`.base-modal-${fieldid}`);
        // if(modalDom){
        //     let modalBody= modalDom.querySelector('.base-modal-body');
        //     if(modalBody && modalAutoFocus){
        //         modalBody.tabIndex = '0';
        //         modalBody.focus();
        //     }
        // }
        // console.log('钩子onShow', fieldid, document, document.querySelector(`.base-modal-${fieldid}`));
        // 暂时兼容onEnter
        let { onEnter, onShow, id } = this.props;
        let modalDom = ReactDOM.findDOMNode(this);
        let modalInner = modalDom && modalDom.querySelector(`.${tinperClsPrefix}-modal`);
        let modalDiolog = modalDom && modalDom.querySelector(`.${defaultModalClassName}`);
        modalInner ? modalInner.id = id : "";
        //滚动条置顶
        if (modalDiolog) {
            modalDiolog.scrollTop = 0;
        }
        if (document.body.clientWidth === 0) {
            //说明页签隐藏了
            this.reRender = true;
        }
        isFunction(onEnter) && onEnter();
        setTimeout(() => {
            this.onEnteredHandle(modalDom);
            isFunction(onShow) && onShow(); //修复bug
        }, 350);
        PubSub.publish('MODAL', { sence: 'modal', currentModal: modalDom });
        document.querySelector('html').classList.add('modal-overflow');
    }

    /**
     * 隐藏结束
     */
    onExitedHandle() {
        let { focusBody = true } = this.props;
        // prevActiveElement 已经取不到了 去掉关闭时的逻辑 避免报错
        // 如果业务有特殊场景  让领域自己处理
        // if ((!this.prevActiveElement || !this.prevActiveElement.parentElement) && focusBody) {
        //     // 如果父级不存在 说明消失了 焦点到body上
        //     document && document.body.focus();
        // }
        this.props.onExited && this.props.onExited();
        // 未传入onCancel和onHide，走tinper默认的头部关闭事件，不走render
        const current = modalManager.get(this.uuid) || {};
        modalManager.set(this.uuid, {
            zIndex: current.zIndex,
            visible: false,
        });
        // console.log('onExitedHandle关闭', this.uuid, modalManager)
        isMax = false;
        document.querySelector('html').classList.remove('modal-overflow');
    }

    /**
     * resize结束时的回调
     * 处理大中小三种类型弹框配置拖拽之后的出现的问题
     */
    // 三个参数 e, dir, elementRef
    onResizeStopHandle = () => {
        let currentModal = ReactDOM.findDOMNode(this);
        let { onResizeStop, indexInfo, className, id } = this.props;
        onResizeStop && onResizeStop();
        PubSub.publish('modelResizeEnd', { indexInfo, className, id });
        PubSub.publish('MODAL', { sence: 'modal', currentModal });
    };

    /**
      * resize开始时的回调
      * 去掉大中小三种类型弹框配置的最大，最大宽度
      */
    onResizeStartHandle = () => {
        let { className, type } = this.props;
        let currentModal = ReactDOM.findDOMNode(this);
        if (currentModal) {
            let modalBody = currentModal.querySelector(`.base-modal-body`);
            if (modalBody) {
                let customType = this.getCustomType(className, type);
                modalBody.style.height = modalBody.offsetHeight + 'px';
                modalBody.style.maxHeight = 'none'; // 去除一下最大高度 避免出现问题
                modalBody.classList.remove(`u-modal-${customType}-body`);
            }
        }
    }

    /**
     * 多个modal显示的层级管理
     * ModalArr在body下ModalArr组成的数组
     */
    // modalIndexManager = ModalArr => {
    //     Array.from(ModalArr).forEach((el, index) => {
    //         for (let attr in modalManager) {
    //             if (el.classList.contains(attr)) {
    //                 let newIndex = index;
    //                 if (
    //                     (el.classList.contains('prompt-box') ||
    //                         el.classList.contains('createNcModal')) &&
    //                     Number(modalManager[attr]) === 200
    //                 ) {
    //                     newIndex = Number(index) + 131;//231改成131,如果有问题再让陈道诚改 NCC-75445这个问题
    //                 }
    //                 let zIndex = Number(modalManager[attr]) + Number(newIndex) + 2;
    //                 this.changeZIndex(ModalArr[index], zIndex);
    //                 // }
    //             }
    //         }
    //     });
    // };

    // changeZIndex = (el, zIndex) => {
    //     el.style.setProperty('z-index', zIndex);
    //     let modalBackDrop = el.previousSibling;
    //     modalBackDrop && modalBackDrop.style.setProperty('z-index', zIndex - 1);
    // };

    //从类名获取当前的modal的是否是大中小自适应类型的弹框
    getCustomType = (className, type) => {
        if (className) {
            if (className.indexOf('junior') !== -1) {
                return 'junior';
            } else if (className.indexOf('senior') !== -1) {
                return 'senior';
            } else if (className.indexOf('combine') !== -1) {
                return 'combine';
            } else if (className.indexOf('prompt-box') !== -1) {
                return 'prompt-box';
            } else if (className.indexOf('createNcModal') !== -1) {
                return 'createNcModal';
            } else if (className.indexOf('bill-track') !== -1) {
                return 'bill-track';
            } else if (className.indexOf('FormulaEditorWrap') !== -1) {
                return 'formula';
            }
        } else if (type) { // 推荐领域使用type
            if (typeMap[type]) {
                return type;
            }
        }
        return '';
    };

    //处理宽高有显示的类型的modal
    // getMinHW = type => {
    //     let info = {};
    //     if (
    //         type === 'junior' ||
    //         type === 'prompt-box' ||
    //         type === 'createNcModal'
    //     ) {
    //         info.height = 201;
    //         info.width = 410;
    //     } else if (type === 'senior') {
    //         info.width = 520;
    //         info.minHeight = 268;
    //         info.maxHeight = 420;
    //     } else if (type === 'combine') {
    //         info.width = 680;
    //         info.minHeight = 268;
    //         info.maxHeight = 570;
    //     }
    //     return info;
    // };

    // 兼容旧版的 弹窗大小 类型
    getModalSize = type => {
        let size = '';
        switch (type) {
            case 'junior':
            case 'prompt-box':
            case 'createNcModal':
                size = 'sm';
                break;
            case 'senior':
                size = 'md';
                break;
            case 'combine':
                size = 'lg';
                break;
            case 'max':
                size = 'max';
                break;
            default:
                break;
        }
        return size;
    };
    /**
     * 当前打开了侧拉 && promptBox的层级+=131
     * NCC-160869 李相相
     */
    hasSideBox = () => {
        return this.defaultBody.querySelector(".card-table-sidebox") || this.defaultBody.querySelector(".card-table-side-box") || this.defaultBody.querySelector(".max-cardTable-backdrop");
    }
    getModalZIndex = (zIndex, visible, defaultZIndex, customType) => {
        // zIndex检查 避免有弹窗显示层级问题,未显示弹窗，现在显示了，需要重新计算层级，已经显示并计算了的，不需要
        const current = modalManager.get(this.uuid) || {};
        // 没有传入zIndex 或者已经计算的zIndex > 传入zIndex
        zIndex = isNaN(zIndex) || (current.zIndex && current.zIndex > zIndex) ? current.zIndex : zIndex;
        // console.log('render模态框', customType, this.uuid, zIndex, visible, !current.visible, className, modalManager, current)
        if (visible && !current.visible) {
            // 取出已经展示弹窗的最高层级
            let topZIndex;
            modalManager.forEach((value, key, map) => {
                if (value.visible && !isNaN(value.zIndex) && (value.zIndex > topZIndex || topZIndex === undefined)) {
                    topZIndex = Number(value.zIndex);
                }
            });
            if (customType === "prompt-box" && zIndex === 200 && this.hasSideBox()) {
                zIndex += 131;
            }
            // 在此之前没有弹窗弹出并弹窗的zIndex没有值，则默认的zIndex为200
            if (isNaN(zIndex) && isNaN(topZIndex)) {
                zIndex = defaultZIndex;
            } else if (isNaN(zIndex) && topZIndex) {
                // 弹窗没有层级，默认添加一层，避免层级错乱
                zIndex = topZIndex + 1;
            } else if (zIndex < topZIndex) {
                // 当前弹窗的zIndex小于最上层
                console.warn('弹窗层级有问题，可以会显示不到最上层');
                zIndex = topZIndex + 1;
            }

            modalManager.set(this.uuid, {
                zIndex,
                visible,
            });
            // console.log('打开模态框', customType, this.uuid, zIndex, visible, modalManager);
        } else {
            modalManager.set(this.uuid, {
                zIndex: current.zIndex,
                visible,
            });
            // console.log('关闭模态框', customType, this.uuid, zIndex, visible, modalManager)
        }
        return zIndex;
    }

    getTopIndex = () => {
        let topZIndex = -1;
        modalManager.forEach((value, key, map) => {
            if (value.visible && !isNaN(value.zIndex) && value.zIndex > topZIndex) {
                topZIndex = Number(value.zIndex);
            }
        });
        return topZIndex;
    }

    render() {
        let boundsContainer = this.defaultBody.id ? `#${this.defaultBody.id}` : 'html';
        let {
            className = "",
            dialogClassName,
            backdropStyle,
            maskStyle,
            indexInfo = {},
            zIndex,
            onEscapeKeyUp,
            onHide,
            onExited,
            onExit,
            onExiting,
            onEnter,
            onShow,
            onEntered,
            fieldid,
            draggable,
            resizable,
            mask,
            backdrop,
            maskClosable,
            onBackdropClick,
            onMaskClick,
            maskClassName,
            backdropClassName,
            visible,
            show,
            getPopupContainer,
            container,
            usePropsContainer = false,
            backdropClosable,
            id,
            footer,
            // 初始位置居中
            centered = 'once',
            // 自定义位置{x,y}
            showPosition,
            size,
            type = '',
            bodyPadding = true,
            bounds = 'html',
            onCancel,
            onResizeStop,
            minHeight,
            ...others
        } = this.props;
        // console.log('渲染modal++=', this.props, Header, Footer);
        // 
        id = indexInfo.id || id || this.uuid;
        visible = visible || show;

        let customType = this.getCustomType(className, type);

        // 修正下zIndex
        zIndex = this.getModalZIndex(indexInfo.zIndex || zIndex, visible, defaultZIndex, customType);
        let topZIndex = this.getTopIndex();
        ViewModel.setData("TOPZINDEX", topZIndex);
        // let customSizeInfo = this.getMinHW(customType);
        // 使用tinper的默认值md
        size = size || this.getModalSize(customType) || 'md';
        // TODO 暂时转换下  等tinper 做完了再换成tinper
        let tempSize = {};
        // if (size === 'xlg') {
        //     tempSize.width = '1100px';
        //     tempSize.height = '560px';
        // }

        if (size === 'flg' || size === 'max') {
            tempSize.width = '95%';
            tempSize.height = '95%';
            // resizable = true;
            // centered = true;
            // draggable = true;
        }

        if (size === "sm") {
            tempSize.minHeight = "180px";
            tempSize.height = "auto"; // tinper默认254px 不符合我们规范 //删除auto 解决YBP-SSC-BUG-509--
            //删除auto会引发YBP-CCF-BUG-1842领域范围较大，平台的历史默认值不能修改 已通知YBP-SSC-BUG-509自行修改
        }
        // this.timer = setTimeout(() => {
        //     //多个模态框叠加显示的层级处理
        //     let ModalArr = document.getElementsByClassName(`.${defaultModalClassName}`);
        //     let ModalInTop = getTopWindow().document.getElementsByClassName(`.${defaultModalClassName}`);
        //     this.modalIndexManager(ModalArr, id);
        //     this.modalIndexManager(ModalInTop, id);
        // });

        if (fieldid) {
            fieldid = fieldid + '_modal-area';
        }
        if (!fieldid) {
            fieldid = '_modal-area';
        }

        fieldid = getSysFieldid(fieldid);
        //不配置backdrop为true或者false的，默认都是点击遮罩禁止关闭
        // if (!mask && mask !== false) {
        //     mask = 'static';
        // }
        let { noFooter, height } = this.props;

        if(size == 'xlg' || size == 'lg'){
            if(this.defaultBodyHeight <= 0){
                this.bodyRect = microAppUtil.getDocument()?.getBoundingClientRect();
                this.defaultBodyHeight = this.bodyRect.bottom - this.bodyRect.top;
            }
            if(0 < this.defaultBodyHeight && this.defaultBodyHeight < 560){ // 弹窗显示不全时改成百分比
                height = '95%';
                if(!minHeight){
                    minHeight = 400;
                }
            }
        }

        return (
            <OriginModal
                fieldid={fieldid}
                autoFocus={true}
                size={size}
                className={
                    classnames(`${id}`,
                        defaultModalClassName,
                        dialogClassName, //兼容tinper将废弃的属性
                        disabledBgBtnHotkey,
                        `${className}`,
                        {
                            'no-footer': noFooter,
                            [type]: type && typeMap[type],
                            'resizable-modal': resizable === undefined ? true : resizable,
                            'default-max-modal': size === "max",
                            'modal-body-padding-none': !bodyPadding,
                        },
                    )
                }
                visible={visible}
                maskClassName={maskClassName || backdropClassName}
                onMaskClick={onMaskClick || onBackdropClick}
                maskStyle={maskStyle ? { ...maskStyle } : { ...backdropStyle }}//建议使用maskStyle
                mask={mask || backdrop}//建议使用mask
                backdrop={mask || backdrop}
                ref={modal => (this.modal = modal)}
                maskClosable={maskClosable || backdropClosable}
                getPopupContainer={getPopupContainer || container || this.getContainer}
                onShow={this.onShowHandle.bind(this)}//建议使用onShow
                // onEnter={this.onEnterHandle.bind(this)}
                // onEntering={this.onEnteringHandle}
                // onExited={this.onExitedHandle.bind(this)}//建议使用onHide
                onHide={this.onExitedHandle.bind(this)}
                onResizeStop={this.onResizeStopHandle}
                onResizeStart={this.onResizeStartHandle}
                // keyboard={true}
                onEscapeKeyUp={this.onEscapeKeyUp.bind(this)}
                onCancel={(event = {}) => {
                    // 解决谷歌版本导致的选中文件弹窗关闭时触发当前事件导致弹窗关闭问题
                    if (event.target && event.target.tagName === 'INPUT') {
                        return;
                    }
                    if (isFunction(onCancel)) {
                        return onCancel();
                    } else {
                        return this.onHide.call(this);
                    }
                }}
                // width={customSizeInfo.width}
                // height={customSizeInfo.height}
                //TODO 影响居中,待钉耙给出方案
                draggable={draggable === undefined ? true : draggable}
                resizable={resizable === undefined ? true : resizable}
                resizeClassName='modal-content-resizeWrap'
                // minHeight={customSizeInfo.minHeight}
                // maxHeight={customSizeInfo.maxHeight}
                //minWidth={customSizeInfo.width ? customSizeInfo.width : undefined}
                centered={centered} //会造成拖拽之后立马回到原来位置的问题 // tinper解决
                showPosition={showPosition}
                header={null}
                zIndex={zIndex}
                footer={footer ? footer : null}
                keyboard={footer ? true : ['esc']}
                footerProps={{ className: footer ? defaultModalFooterClassName : "", fieldid: 'bottom-area' }}
                bounds={bounds}
                height={height}
                minHeight={minHeight}
                {...tempSize}
                {...others}
                enforceFocus={false}
            />
        );
    }
}

class Header extends Component {
    constructor(props) {
        super(props);
    }
    onMaximize = flag => {
        isMax = flag;
        const { maxButtonClick } = this.props;
        maxButtonClick && maxButtonClick(flag);
        let currentModal = ReactDOM.findDOMNode(this).parentElement;
        PubSub.publish('MODAL', { sence: 'modal', currentModal });
    }
    render() {
        let { fieldid, closeButton, showMaxButton, headerRight, max, maxButtonClick, className, maximize, confirmCancel, ...others } = this.props;
        const closeTooltipText = langJson["icon-close"] || "关闭";
        const maxTooltipText = langJson["icon-max-zoom"] || "最大化";
        const resetTooltipText = langJson["icon-reset-zoom"] || "还原";
        const renderCloseButton = (
            <Tooltip
                placement="top"
                overlay={closeTooltipText}
                delayHide={1}
                delayShow={1000}>
                <div
                    className="base-modal-header-close iconfont icon-guanbi"
                    key="5"
                    onClick={
                        confirmCancel ? e => {
                            e.stopPropagation();
                            confirmCancel();
                        } :
                            () => { }} />
            </Tooltip>);
        const renderMaxButton = (
            <Tooltip
                placement="top"
                overlay={isMax ? resetTooltipText : maxTooltipText}
                delayHide={1}
                delayShow={1000}>
                <div
                    className={`base-modal-header-max iconfont ${isMax ? 'icon-danchuangzuixiaohua' : 'icon-danchuangzuidahua'}`}
                    key="4"
                />
            </Tooltip>);

        let closeButtonProps = {};
        if (closeButton) {
            closeButtonProps.fieldid = 'close_btn';
        }

        if (!fieldid) {
            fieldid = 'header-area';
        }
        fieldid = getSysFieldid(fieldid);
        let headerName = `${defaultModalHeaderClassName} ${className || ''}`;
        return (
            <OriginModal.Header
                fieldid={fieldid}
                closeButtonProps={closeButtonProps}
                closeButton={closeButton}
                renderCloseButton={() => renderCloseButton}
                {...others}
                maximize={maximize || showMaxButton}
                onMaximize={flag => this.onMaximize(flag)}
                renderMaximizeButton={() => renderMaxButton}
                className={headerName}
            >
                {this.props.children}
                < div className={
                    classnames(
                        "modal-header-right dnd-cancel",
                        { "have-max": showMaxButton },
                    )
                } >
                    {headerRight ? headerRight() : ''}
                    {/* {showMaxButton ? <MaxZoomBtn max={max} onClick={(max, e) => {
                        e.preventDefault();
                        maxButtonClick && maxButtonClick(max, e);
                    }} /> : ''} */}
                </div >
            </OriginModal.Header >
        );
    }
}

class Title extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        let { fieldid, className = '', needShowFieldId = true, ...others } = this.props;

        //传了fieldid使用传的内容做标记
        if (fieldid) {
            fieldid = fieldid + '_title';
        } else {
            // 业务组未传fieldid的,使用children作为标记
            fieldid =
                typeof this.props.children === 'string'
                    ? `${this.props.children}_title`
                    : '_title';
        }
        fieldid = getSysFieldid(fieldid);
        if (needShowFieldId) {
            others.fieldid = fieldid;
        }

        return (
            <OriginModal.Title {...others} className={`${className} base-modal-title`}>
                {this.props.children}
            </OriginModal.Title>
        );
    }
}

class Body extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        let { className = '', bodyPadding = true, ...others } = this.props;
        // console.log(this.props, 'BodyBodyBodyBodyBodyBodyBody');
        return (
            <OriginModal.Body {...others} className={classnames(defaultModalBodyClassName, className, { 'base-modal-body-padding-none': !bodyPadding })}>
                {this.props.children}
            </OriginModal.Body>
        );
    }
}

class Footer extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        let { fieldid, className, ...others } = this.props;
        // console.log(this.props, 'FooterFooterFooter');
        if (!fieldid) {
            fieldid = 'bottom-area';
        }
        let footerName = `${defaultModalFooterClassName} ${className || ''}`;
        fieldid = getSysFieldid(fieldid);
        return <OriginModal.Footer {...others} fieldid={fieldid} className={footerName} />;
    }
}
Header.defaultProps = headerDefaultProps;
Title.defaultProps = titleDefaultProps;
Body.defaultProps = bodyDefaultProps;
Footer.defaultProps = footerDefaultProps;
Modal.defaultProps = modalDefaultProps;

Modal.Header = Header;
Modal.Title = Title;
Modal.Body = Body;
Modal.Footer = Footer;

export default Modal;

// Modal.Header = Modal.Header;
// Modal.Title = Modal.Title;
// Modal.Body = Modal.Body;
// Modal.Footer = Modal.Footer;
